import { render } from "./Wish.vue?vue&type=template&id=cbc91ca2&scoped=true"
import script from "./Wish.vue?vue&type=script&lang=js"
export * from "./Wish.vue?vue&type=script&lang=js"

import "./Wish.vue?vue&type=style&index=0&id=cbc91ca2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-cbc91ca2"

export default script